import { post, parseData } from '../api/common';
const login = (username, password) => post('/InternalAPI/LoginAPI.asmx/Login', { username, password })
    .then(parseData)
    .then((response) => response.Data)
    .then((data) => {
    if (data !== '0') {
        throw new Error('Invalid username or password');
    }
});
export default login;
